module.exports = __webpack_public_path__ + "ae6e73ec6bf2ce7b0259dd05dbf43be4.png";